import React from 'react';

import classNames from 'classnames';

import './styles.css';

const Ellipsis = ({children, className}: any) => (
  <span className={classNames('Ellipsis', className)}>{children}</span>
);

export default Ellipsis;
